import { FaClipboardList } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { InstallationPickerRow } from "../installation/InstallationPickerSheet";
import { buildMetadataSummary } from "./photoCaptureMobileUtils";

const PhotoCaptureMetadataEntry = ({
  clientOptions,
  wasteCategoryOptions,
  selectedClient,
  selectedWasteCategory,
  identificationReference,
  weightTonnes,
  commentText,
  onOpen,
  disabled = false,
  isLoadingOptions = false,
}) => {
  const { t } = useTranslation();
  const summary = buildMetadataSummary({
    t,
    clientOptions,
    wasteCategoryOptions,
    selectedClient,
    selectedWasteCategory,
    identificationReference,
    weightTonnes,
    commentText,
  });

  return (
    <div className="installation-settings-card photo-capture-metadata-entry-card">
      <InstallationPickerRow
        icon={FaClipboardList}
        iconVariant="default"
        title={t("mobile_photo_metadata_entry_title")}
        subtitle={summary}
        placeholder={t("mobile_photo_metadata_entry_placeholder")}
        onClick={onOpen}
        disabled={disabled || isLoadingOptions}
      />
    </div>
  );
};

export default PhotoCaptureMetadataEntry;
